export const TemplateTypes = {
  Quote: 'quote',
  Master: 'master',
  Document: 'document',
  Notification: 'notification',
} as const;
